const PUBLISHABLE_KEY = "pk_test_E6YHok0yhWKkqhkeq3WY5cn400r4mmDlsN";
const URL = "https://nagrand-hotel.herokuapp.com" || "http://localhost:4000";
// "http://localhost:4000";
// "https://nagrand-hotel.herokuapp.com" ||

export { PUBLISHABLE_KEY, URL };
